import React, { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { Link } from 'react-router-dom'

export default function Login() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await signIn(email, password)
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}>🌿</div>
          <h1 style={styles.logoText}>TLC Unlimited</h1>
          <p style={styles.logoSub}>Field Operations</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
          <div style={{ textAlign: 'center', marginTop: '8px' }}>
            <Link to="/portal/login" style={styles.portalLink}>
              🔗 Client Portal Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a2e1a 0%, #2d4a2d 50%, #1a3320 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: "'DM Sans', sans-serif"
  },
  card: {
    background: 'rgba(255,255,255,0.97)',
    borderRadius: '16px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 25px 60px rgba(0,0,0,0.4)'
  },
  logo: { textAlign: 'center', marginBottom: '36px' },
  logoIcon: { fontSize: '48px', marginBottom: '8px' },
  logoText: { margin: 0, fontSize: '28px', fontWeight: '700', color: '#1a2e1a', letterSpacing: '-0.5px' },
  logoSub: { margin: '4px 0 0', color: '#6b7c6b', fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#374151', letterSpacing: '0.5px', textTransform: 'uppercase' },
  input: {
    padding: '12px 16px', borderRadius: '8px', border: '1.5px solid #d1d5db',
    fontSize: '16px', outline: 'none', transition: 'border-color 0.2s',
    fontFamily: 'inherit'
  },
  button: {
    padding: '14px', background: '#2d4a2d', color: 'white', border: 'none',
    borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer',
    marginTop: '8px', letterSpacing: '0.5px'
  },
  error: {
    background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626',
    padding: '12px', borderRadius: '8px', fontSize: '14px'
  },
  portalLink: {
    color: '#4a6a4a', fontSize: '13px', textDecoration: 'none',
    fontWeight: '500', letterSpacing: '0.2px',
  }
}
